import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

const getDisplayValue = (item, col) => {
  const rawValue = item?.values?.[col.columnHeader]?.[col.columnName];

  if (rawValue === null || rawValue === undefined || rawValue === "") {
    return "";
  }

  const numericValue = Number(rawValue);

  if (!Number.isNaN(numericValue) && numericValue === 0) {
    return "-";
  }

  return rawValue;
};

export default function ReportItemQualifiedGroupOverview({
  item,
  isOdd,
  type,
  allColumns = [],
  dataColumnWidth,
}) {
  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      <div
        className={styles.qualifiedGroup}
        style={{
          fontWeight: type === "total" ? "700" : "400",
        }}
      >
        {item.qualifiedGroup}
      </div>

      {allColumns.map((col, index) => {
        const value = getDisplayValue(item, col);
        const isFirstInGroup =
          index === 0 ||
          allColumns[index - 1]?.columnHeader !== col.columnHeader;

        return (
          <div
            key={`${col.id}-${index}`}
            className={styles.col}
            style={{
              width: dataColumnWidth,
              borderLeft: isFirstInGroup
                ? "2px solid #000"
                : "1px solid #e0e0e0",
              fontWeight: type === "total" ? "700" : "400",
            }}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
}

ReportItemQualifiedGroupOverview.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
  allColumns: PropTypes.array,
  dataColumnWidth: PropTypes.string,
};
